<div class="autologout-dialog">
  <h2 *ngIf="data.title" matDialogTitle>{{data.title}}</h2>
  <p [innerHTML]="data.message"></p>
  <div class="countdown">{{ countdown }}</div>
  <mat-dialog-actions>
    <button (click)="dialogRef.close(true)" color="primary" mat-raised-button type="button">{{data.buttons[0]}}</button>
    <button mat-button (click)="dialogRef.close('logout')" type="button">{{data.buttons[1]}}</button>
  </mat-dialog-actions>
</div>
